import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCandidate } from "../../../../redux/actions/admin/CandidateActions";
import localStorageService from "../../../../services/localStorageService";
import { CircularProgress } from "@material-ui/core";
import jsPDF from "jspdf";
import moment from "moment";
import "moment/locale/fr";

const ResumeTemplate3 = ({ storeCandidate, getCandidate }) => {
  const [candidateId, setCandidateId] = useState("");
  const [candidate, setCandidate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [initials, setInitials] = useState("");

  useEffect(() => {
    const candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) setCandidateId(candidate.id);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!candidateId) return;

    const fetchCandidate = async () => {
      setIsLoading(true);
      const candidateData =
        storeCandidate.candidate || (await getCandidate(candidateId));
      setCandidate(candidateData);
      setIsLoading(false);

      if (candidateData?.firstName && candidateData?.lastName) {
        setInitials(
          `${candidateData.firstName.charAt(0)}/${candidateData.lastName.charAt(
            0
          )}`
        );
      }
    };

    fetchCandidate();
  }, [candidateId]);

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.html(document.querySelector(".cv-container"), {
      callback: (doc) => doc.save("resume.pdf"),
    });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loading-container">
          <CircularProgress />
          <div>Chargement du cv en cours...</div>
        </div>
      ) : (
        <>
          <div className="cv-container">
            <style>
              {`
           
* {
        box-sizing: border-box;
        transition: 0.35s ease;
      }
      .rela-block {
        display: block;
        position: relative;
        margin: auto;
      }
      .rela-inline {
        display: inline-block;
        position: relative;
        margin: auto;
      }
      .floated {
        display: inline-block;
        position: relative;
        margin: false;
      }
      .abs-center {
        display: false;
        position: absolute;
        margin: false;
        top: 50%;
        left: 50%;
        right: false;
        bottom: false;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 88%;
      }
      /* --- COLORS --- */

      /* --- PAGE STYLINGS --- */
      body {
        font-family: "Open Sans", sans-serif;
        font-size: 18px;
        letter-spacing: 0px;
        font-weight: 400;
        line-height: 28px;
        background: url("http://kingofwallpapers.com/leaves/leaves-016.jpg")
          right no-repeat;
        background-size: cover;
      }
      body:before {
        content: "";
        display: false;
        position: fixed;
        margin: 0;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.92);
      }
      .caps {
        text-transform: uppercase;
      }
      .justified {
        text-align: justify;
      }
      p.light {
        color: #777;
      }
      h2 {
        font-family: "Open Sans", sans-serif;
        font-size: 30px;
        letter-spacing: 5px;
        font-weight: 600;
        line-height: 40px;
        color: black;
      }
      h3 {
        font-family: "Open Sans", sans-serif;
        font-size: 21px;
        letter-spacing: 1px;
        font-weight: 600;
        line-height: 28px;
        color: black;
      }
      .page {
        width: 90%;
        max-width: 1200px;
        margin: 80px auto;
        background-color: white;
        box-shadow: 6px 10px 28px 0px rgba(0, 0, 0, 0.4);
      }
      .top-bar {
        height: 220px;
        background-color: #848484;
        color: white;
      }
      .name {
        display: false;
        position: absolute;
        margin: false;
        top: false;
        right: 0;
        bottom: 0;
        left: calc(350px + 5%);
        height: 120px;
        text-align: center;
        font-family: "Raleway", sans-serif;
        font-size: 58px;
        letter-spacing: 8px;
        font-weight: 100;
        line-height: 60px;
      }
      .name div {
        width: 94%;
      }
      .side-bar {
        display: false;
        position: absolute;
        margin: false;
        top: 60px;
        right: false;
        bottom: 0;
        left: 5%;
        width: 350px;
        background-color: #f7e0c1;
        padding: 320px 30px 50px;
      }
      .mugshot {
        display: false;
        position: absolute;
        margin: false;
        top: 50px;
        right: false;
        bottom: false;
        left: 70px;
        height: 210px;
        width: 210px;
      }
      .mugshot .logo {
        margin: -23px;
      }
      .logo {
        position: absolute;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 250px;
        width: 250px;
        z-index: 100;
        color: black;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      .logo-svg {
        height: 100%;
        width: 100%;
        stroke: black;
        cursor: pointer;
      }
      .logo-text {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
        font-family: "Montserrat", sans-serif;
        font-size: calc(250px / 5 + 250px / 50);
        letter-spacing: 0px;
        font-weight: 400;
        line-height: calc(250px / 5 + 250px / 30);
        margin: 0;
      }
      
     
      .side-header {
        font-family: "Open Sans", sans-serif;
        font-size: 18px;
        letter-spacing: 4px;
        font-weight: 600;
        line-height: 28px;
        margin: 10px auto 10px;
        padding-bottom: 5px;
        border-bottom: 1px solid #888;
      }
      .list-thing {
        padding-left: 25px;
        margin-bottom:10px;
      }
      .content-container {
        margin-right: 0;
        width: calc(95% - 350px);
        padding: 25px 40px 50px;
      }
      .content-container > * {
        margin: 0 auto 25px;
      }
      .content-container > h3 {
        margin: 0 auto 5px;
      }
      .content-container > p.long-margin {
        margin: 0 auto 50px;
      }
      .title {
        width: 80%;
        text-align: center;
      }
      .separator {
        width: 240px;
        height: 2px;
        background-color: #999;
      }
      .greyed {
        background-color: #ddd;
        width: 100%;
        max-width: 580px;
        text-align: center;
        font-family: "Open Sans", sans-serif;
        font-size: 18px;
        letter-spacing: 6px;
        font-weight: 600;
        line-height: 28px;
      }
        .button-container {
            position: fixed;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            flex-direction: column;
            gap: 10px;
          }

          .btn {
              padding: 12px 20px;
              font-size: 16px;
              cursor: pointer;
              border: none;
              border-radius: 5px;
              color: #fff;
              background-color: #333;
          }

          .btn-download {
              background-color: #5cb85c;
          }
              
      @media screen and (max-width: 1150px) {
        .name {
          color: white;
          font-family: "Raleway", sans-serif;
          font-size: 38px;
          letter-spacing: 6px;
          font-weight: 100;
          line-height: 48px;
        }
      }

      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          background: none !important;
          color: #000 !important;
        }
        .container {
          display: block !important;
          max-width: 100% !important;
          background-color: #fff !important;
          margin: 0 !important;
          box-shadow: none !important;
          padding: 0 !important;
        }
        .profile {
          background-color: #39383a !important;
          color: #ababab !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        .profile-photo {
          background-size: cover !important;
          background-position: top !important;
          background-repeat: no-repeat !important;
        }
        .profile-info,
        .resume {
          padding: 0 !important;
          margin: 0 !important;
        }
        .resume {
          background-color: #fff !important;
          color: #000 !important;
        }
        .list-item:before {
          background-color: #000 !important;
        }
        .contacts-title,
        .contacts-text,
        .contacts-item,
        address,
        .languages,
        .language-text,
        .languages-per,
        .lines,
        .line,
        .heading,
        .about,
        .position,
        .about-address,
        .about-contacts,
        .about-contacts__link,
        .heading_dark,
        .list,
        .list-item,
        .list-item__title,
        .list-item__date,
        .list-item__text,
        .skills-list,
        .skills-list__item,
        .level,
        .level:before,
        .level-80:before,
        .level-90:before,
        .level-50:before,
        .heading_skills {
          color: #000 !important;
          background: none !important;
          border: none !important;
        }
          .button-container, .footer {
              display: none;
            }
      }


      `}
            </style>
            <div className="rela-block page">
              <div className="rela-block top-bar">
                <div className="caps name">
                  <div className="abs-center">
                    {candidate?.firstName} {candidate?.lastName}
                  </div>
                </div>
              </div>
              <div className="side-bar">
                <div className="mugshot">
                  <div className="logo">
                    <svg viewbox="0 0 100 100" className="rela-block logo-svg">
                      <path
                        d="M 10 10 L 52 10 L 72 30 L 72 70 L 30 70 L 10 50 Z"
                        strokeWidth="2.5"
                        fill="none"
                      />
                    </svg>
                    <p className="logo-text">{initials}</p>
                  </div>
                </div>
                <p className="rela-block caps side-header">Contact</p>
                <p className="rela-block list-thing">
                  {candidate?.phoneNumber1}
                </p>
                <p>{candidate?.email}</p>
                <br />
                <p className="rela-block caps side-header">Expertise</p>
                {candidate?.skills && candidate?.skills.length > 0
                  ? candidate?.skills.map((skill, index) => (
                      <p className="rela-block list-thing">{skill?.title}</p>
                    ))
                  : null}
                <p className="rela-block caps side-header">Education</p>
                <div>
                  {candidate?.educations.map((edu, index) => (
                    <>
                      <p className="rela-block list-thing">
                        {moment(edu?.endYear).format("YYYY")} -{" "}
                        {moment(edu?.startYear).format("YYYY")} * {edu?.degree}
                      </p>
                    </>
                  ))}
                </div>
              </div>
              <div className="rela-block content-container">
                <div className="rela-block separator"></div>
                <div className="rela-block caps greyed">Profile</div>
                <div
                  className="html-content summary-content long-margin"
                  dangerouslySetInnerHTML={{ __html: candidate?.summary }}
                />
                <div className="rela-block caps greyed">Experience</div>
                {candidate?.workExperiences.map((job, index) => (
                  <>
                    <h3>{job?.title}</h3>
                    <p className="light">
                      {moment(job?.startDate).format("YYYY")} -{" "}
                      {moment(job?.endDate).format("YYYY")}
                    </p>
                    <p className="justified">{job?.description}</p>
                  </>
                ))}
              </div>
            </div>
            <div className="button-container">
              <button className="btn btn-print" onClick={() => window.print()}>
                Imprimer mon CV
              </button>
              <button className="btn btn-download" onClick={downloadPDF}>
                Télécharger le PDF
              </button>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

ResumeTemplate3.propTypes = {
  storeCandidate: PropTypes.object.isRequired,
  getCandidate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  storeCandidate: state.candidate,
});

export default connect(mapStateToProps, { getCandidate })(ResumeTemplate3);
